'use client';

import type { ReactNode } from 'react';
import parse from 'html-react-parser';

import { cn } from '@/lib/utils';

import { Card } from '@/components/atoms/Card';
import { LocalImage } from '@/components/atoms/LocalImage';
import H5 from '@/components/atoms/Typography/H5';
import { P } from '@/components/atoms/Typography/P';

import type { CarouselCardProps } from '../CarouselSection.types';

export default function CarouselCard({
    image,
    title,
    subtitle,
    content,
    className,
    isActive,
    ...props
}: CarouselCardProps): ReactNode {
    return (
        <Card
            size="l"
            variant="shadow"
            className={cn(
                'mx-6 mb-4 mt-2 h-[440px] w-[280px] md:my-8 md:h-[528px] md:w-[360px]',
                'flex flex-col items-center text-sm sm:p-6 sm:text-2xs md:p-8',
                isActive && 'border border-green-500 bg-green-100',
                className,
            )}
            {...props}
        >
            <LocalImage
                width={190}
                height={140}
                className="mb-6 h-[120px] w-48 md:mb-8 md:h-[140px]"
                {...image}
            />

            <H5 className="text-center">{title}</H5>

            <P
                size="2xs"
                weight="bold"
                className="mb-4"
            >
                {subtitle}
            </P>

            <P
                size="2xs"
                className="text-center md:text-sm"
            >
                {parse(content)}
            </P>
        </Card>
    );
}
